export const SIGNALR_WORKOUT_HUB = {
  ENDPOINT: '/hubs/workout-plan-jobs',
} as const;

export const SIGNALR_WORKOUT_EVENTS = {
  JOB_UPDATED: 'WorkoutPlanJobStatusUpdated',
} as const;

export const SIGNALR_WORKOUT_METHODS = {
  SUBSCRIBE: 'SubscribeToEmployeeJobsAsync',
  UNSUBSCRIBE: 'UnsubscribeFromEmployeeJobsAsync',
} as const;
